<template>
    <input
        class="form-control"
        v-maska="'+38 (###) ###-##-##'"
        :value="phoneValue"
        @input="phoneValue = $event.target.value"
        placeholder="+38 (999) 999-99-99"
        :disabled="disabled"
        :readonly="readonly"
    />
</template>
<script>
import { vMaska } from "maska/vue"

export default {
    name: 'PhoneInput',
    directives: { maska: vMaska },
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            phoneValue: null
        }
    },
    methods: {
        cleanPhoneNumber(phone) {
            if (!phone) return '';
            return phone.replace(/[^\d+]/g, '');
        }
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                this.phoneValue = newValue;
            }
        },
        phoneValue(newValue) {
            const cleaned = this.cleanPhoneNumber(newValue);
            this.$emit('update:modelValue', cleaned);
        }
    }
}
</script>
